// extracted by mini-css-extract-plugin
module.exports = {"slot":"TimelineSlot_slot__Zlhac"};